import {AdditionalPaymentOption} from "../../pms-api/models";

export const filterDropMethods = paymentOptions => paymentOptions.filter(option => {

    const additionalPayment = new AdditionalPaymentOption();

    return option.type === 'bank-transfer'
        || (option.type === 'custom' && option.model.type === additionalPayment.TYPE_CASH);

}).map(option => {

    if (option.type === 'bank-transfer') {

        option.name = 'Bank Deposit';
        option.name_ar = 'إيداع بنكي';
    }

    return option;
});



// WEBPACK FOOTER //
// ./src/app/helpers/filter-drop.methods.js